const sliders = () => {
    //main-slider
    $('.slider__wrapper').slick({
        dots: true,
        arrows: false,
        speed: 1200,
        slidesToShow: 1,
        prevArrow: '<button type="button" class="slick-prev"><img src="icons/arrow-left.svg"></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="icons/arrow-right.svg"></button>',
    });

    //feedback-slider
    $('.feedback__wrapper').slick({
        dots: true,
        speed: 1200,
        slidesToShow: 1,
        adaptiveHeight: true,
        prevArrow: '<button type="button" class="slick-prev"><img src="icons/arrow-left.svg"></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="icons/arrow-right.svg"></button>',
        responsive: [{
            breakpoint: 769,
            settings: {
                arrows: false,
                centerMode: false
            }
        }]
    });

    //ordering-slider
    $('.ordering__slider-wrapper').slick({
        dots: false,
        arrows: false,
        autoplay: false,
        infinite: false,
        speed: 1200,
        slidesToShow: 4,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                infinite: false,

            }
        }]
    });

    //blog-page slider
    $('.page__slider').slick({
        dots: true,
        speed: 1200,
        // centerMode: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        prevArrow: '<button type="button" class="slick-prev"><img src="icons/arrow-left.svg"></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="icons/arrow-right.svg"></button>',
        responsive: [{
            breakpoint: 1024,
            settings: {
                centerMode: false
            }
        }]
    });

    //product-card slider
    $('.result__slider').slick({
        dots: true,
        arrows: true,
        autoplay: true,
        speed: 1200,
        slidesToShow: 1,
        prevArrow: '<button type="button" class="slick-prev"><img src="icons/slider-left.svg"></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="icons/slider-right.svg"></button>',
        responsive: [{
            breakpoint: 768,
            settings: {
                arrows: false
            }
        }]
    });
};

export default sliders;